module.exports = "/images/vendor/flag-icon-css/flags/4x3/ai.svg?c2f29c4d57cfcba3c9b2374b2c7e461f";